import axiosPost from "./axiosPost";

export const RNHDivisionGet = async (credentials, data) => {
    const body = {
        service: "RNHDivisionGet",
        params: {
            rnhDivisionId: data?.id || null,
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
